var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Christian Cross"),React.createElement("path",{"transform":"translate(2,2)scale(2,2)","fill":"white","d":"M0,80H80V0H120V80H200V120H120V280H80V120H0V80Z","key":1})]);
}

Icon.defaultProps = {"width":"404","height":"564","viewBox":"0 0 404 564"};

module.exports = Icon;

Icon.default = Icon;
